
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function MockTestPreview() {
  const benefits = [
    "Full-length mock tests simulating actual exam conditions",
    "Exam-specific question patterns and difficulty levels",
    "Detailed performance analytics after each test",
    "Personalized feedback on your test-taking strategy",
    "Topic-wise analysis of strengths and weaknesses",
    "Unlimited mock tests for comprehensive practice"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/0ba1169a-47b7-438b-887b-341cdaac6d81.png",
      caption: "Mock Tests - Practice under exam conditions"
    },
    {
      url: "/lovable-uploads/33bc094b-26ce-4555-a3cb-93d8d930b297.png",
      caption: "Collaborative Learning - Connect with peers for group study"
    }
  ];

  return (
    <FeatureShowcase
      title="Advanced Mock Tests"
      description="Practice with exam-like conditions and get detailed performance insights."
      featureName="Mock Tests"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
